import { render, staticRenderFns } from "./buttonBlock.vue?vue&type=template&id=617f7814&scoped=true"
import script from "./buttonBlock.vue?vue&type=script&lang=js"
export * from "./buttonBlock.vue?vue&type=script&lang=js"
import style0 from "./buttonBlock.vue?vue&type=style&index=0&id=617f7814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f7814",
  null
  
)

export default component.exports